import qs from 'qs';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import {
  InquiryTemplateVersion,
  InquiryTemplateVersionSchema,
} from 'dashboard/models/inquiry-template-version';
import { InquiryIso6391LanguageCode } from 'lib/constants/locales';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';
import { StepPreview } from 'lib/interfaces/StepsConfig';

const fetchInquiryTemplateAndVersion = async ({
  inquiryTemplateVersionId,
}: {
  inquiryTemplateVersionId: string;
}): Promise<{
  inquiryTemplateVersion: InquiryTemplateVersion;
  inquiryTemplate: InquiryTemplate;
}> => {
  const { data: inquiryTemplateVersion, included } =
    await SessionClientDashboard.getResource<InquiryTemplateVersion>(
      ApiEndpoint.InquiryTemplateVersion,
      inquiryTemplateVersionId,
    );

  const inquiryTemplate = (included || []).find(
    (entity) => entity.type === ApiModel.InquiryTemplate,
  ) as InquiryTemplate;

  return { inquiryTemplateVersion, inquiryTemplate };
};

const fetchInquiryTemplateVersionStepsPreview = async ({
  inquiryTemplateVersionId,
  locale,
}: {
  inquiryTemplateVersionId: string;
  locale: InquiryIso6391LanguageCode;
}): Promise<StepPreview[]> => {
  const { meta } = await SessionClientDashboard.getResource<
    InquiryTemplateVersion,
    { steps: StepPreview[] }
  >(
    ApiEndpoint.InquiryTemplateVersion,
    `${inquiryTemplateVersionId}/steps-as-client-data?${qs.stringify({
      locale: locale,
    })}`,
  );
  return meta ? meta.steps : [];
};

const fetchInquiryTemplateVersionSchema = async ({
  inquiryTemplateVersionId,
}: {
  inquiryTemplateVersionId: string;
}): Promise<InquiryTemplateVersionSchema> => {
  const { meta: schema } = await SessionClientDashboard.getResource<
    InquiryTemplateVersion,
    InquiryTemplateVersionSchema
  >(ApiEndpoint.InquiryTemplateVersion, `${inquiryTemplateVersionId}/schema`);

  return schema as InquiryTemplateVersionSchema;
};

export {
  fetchInquiryTemplateAndVersion,
  fetchInquiryTemplateVersionStepsPreview,
  fetchInquiryTemplateVersionSchema,
};
